import { Button } from "@material-ui/core"
import { KeyValueModel } from "model"
import { memo } from "react"
import { useStyles } from "./button-options-styles"
import classNames from "classnames"

export interface ButtonOptionsProps {
    option: KeyValueModel,
    setSelected: React.Dispatch<React.SetStateAction<any>>,
    selected: boolean
    isSistema?: boolean
}

export const ButtonOptions = memo(({
    option,
    setSelected,
    selected,
    isSistema
}: ButtonOptionsProps) => {
    const classes = useStyles()

    return (
        <Button
            variant={'text'}
            onClick={() => setSelected(option.Key)}
            color={selected ? "primary" : "inherit"}
            className={classNames(selected ? classes.button : null, isSistema && classes.sistema)}
        >
            {option.Value}
        </Button>
    )
})